var map = {
	"./geniusfeed.json": 7158,
	"./pixup.json": 9929,
	"./sportsbookcore.json": 2794,
	"config/themes/geniusfeed.json": 7158,
	"config/themes/pixup.json": 9929,
	"config/themes/sportsbookcore.json": 2794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;